import { Component, HostListener, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  showFooter = false;
  showBackToTop = false;

  private destroy$ = new Subject<void>();

  constructor(private router: Router, private viewportScroller: ViewportScroller) {

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: any) => {

        const path = event.urlAfterRedirects.split('?')[0];

        const homeRoutes = [
          '/',
          '/home-one',
          '/home-two',
          '/home-three',
          '/home-four'
        ];

        this.showFooter = homeRoutes.includes(path);

        setTimeout(() => {
          this.viewportScroller.scrollToPosition([0, 0]);
        }, 100);

      });
  }

  // Window scroll detection
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.showBackToTop = window.pageYOffset > 200;
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
